import { Modal } from "antd";
import styled from "styled-components";

export const DeleteFromPlayModal = styled(Modal)`
  .heading {
    font-size: 26px;
    color: ${(props) => props.theme.colors.primary};
  }
  .row-center {
    display: flex;
    justify-content: center;
  }
  .spanner {
    font-size: 15px;
    color: white;
    display: flex;
  }
  .spanner1 {
    margin-left: 5px;
  }
  .icons {
    font-size: 20px;
    margin-top: 2px;
  }

  .btn1 {
    padding:  20px;
    font-size: 16px;
    border: 2px solid #007aff;
    background: transparent;
    color: #007aff;
  }

  .btn2 {
    padding:  20px;
    border: 2px solid #007aff;
    font-size: 16px;
    background: #007aff;
    margin-left: 20px;
  }

  .p5 {
    padding: 0px 0px 30px;
    color: #788c9b;
  }

  .row-space {
    display: flex;
    justify-content: space-between;
  }

  .h4 {
    font-weight: 600;
    color: ${(props) => props.theme.colors.primary};
    font-size: 19px;
    padding: 20px 0px 10px;
  }

  .description {
    font-size: 16px;
    color: ${(props) => props.theme.colors.primary};
  }

  .ant-modal-content {
    background-color: ${(props) => props.theme.background.secondary};
    color: ${(props) => props.theme.colors.primary};
    width: 600px;
    border: 1px solid white;
    border-radius: 7px;
    margin-left: -60px;
  }

  .ant-picker.ant-picker-disabled {
    background-color: transparent;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .ant-select-selection-item {
    font-size: 17px !important;
  }
  .ant-select-selector {
    height: 49px !important;
  }

  .form-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .date {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .toggle-wrapper {
    display: flex;
    gap: 10px;

    & > label {
      font-size: 16px;
    }
  }
  .ant-modal-mask {
    backdrop-filter: blur(5px) !important;
  }
  .footer {
    display: flex;
    gap: 5px;
    align-self: flex-end;
  }

  .row-space {
    flex-direction: row;
  }

  .btn2 {
    margin-bottom: 0px;
  }

  .DeleteFromPlayModalAlertWarning1 {
    display: block;
  }

  .DeleteFromPlayModalAlertWarning2 {
    display: none;
  }

  @media only screen and (max-width: 600px) {
    .ant-modal-content {
      width: 100%;
      margin-left: 0%;
    }
    .h4 {
      font-size: 14px !important;
    }

    .p5 {
      font-size: 12px;
    }

    .row-space {
      flex-direction: column-reverse;
    }

    .btn1 {
      font-size: 14px;
    }

    .DeleteFromPlayModalAlertWarning1 {
      display: none;
    }

    .DeleteFromPlayModalAlertWarning2 {
      display: block;
    }

    .btn2 {
      margin-left: 0px !important;
      margin-bottom: 20px;
      font-size: 14px;
    }
  }
`;

export const DeletePlayModal = styled.div`
  .spanner {
    font-size: 15px;
    color: ${(props) => props.theme.colors.primary};
    display: flex;
  }
  .spanner1 {
    margin-left: 5px;
  }
  .icon1 {
    font-size: 18px;
  }
  .icons {
    font-size: 20px;
    margin-top: 2px;
  }
`;
